import { Dialog, Button, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { TransactionStatus } from 'src/type/transaction';
import Label from 'src/components/label';
import { fDate } from 'src/utils/format-time';
import InfoGrid from 'src/components/ui-kit/info-grid';
import ImageWithPreview from 'src/components/ui-kit/image-with-preview';
import { TopupTxType } from 'src/type/topup-deposit';
import { txStatusLabel } from '../__gold-withdraw/utils';
import { statusAction } from './utils';

type Props = {
  open: boolean;
  onClose: VoidFunction;
  tx: TopupTxType;
};

export default function TopupViewDialog({ open, onClose, tx }: Props) {
  const getInfo = () => {
    if (!tx) return [];

    const { status, createdAt, updatedAt, user, note, paymentImageUrl } = tx;

    return [
      {
        label: 'สถานะ',
        value: (
          <Label
            variant="soft"
            color={
              (status === TransactionStatus.SUCCESS && 'success') ||
              (status === TransactionStatus.PENDING && 'warning') ||
              (status === TransactionStatus.REJECTED && 'error') ||
              (status === TransactionStatus.CANCEL && 'info') ||
              'default'
            }
          >
            {txStatusLabel(status)}
          </Label>
        ),
      },
      { label: 'ผู้ใช้งาน', value: `${user?.firstName} ${user?.lastName}` },

      { label: 'วันที่ทำรายการ', value: fDate(createdAt, 'DD MMMM BBBB HH:mm น.') },
      ...([TransactionStatus.SUCCESS, TransactionStatus.REJECTED].includes(status)
        ? [
            {
              label: `วันที่${statusAction(status)}`,
              value: fDate(updatedAt, 'DD MMMM BBBB HH:mm น.'),
            },
          ]
        : []),
      ...(paymentImageUrl
        ? [
            {
              label: 'หลักฐานการโอนเงิน',
              value: <ImageWithPreview src={paymentImageUrl} alt="" />,
            },
          ]
        : []),
      {
        label: 'หมายเหตุ',
        value: note || '-',
      },
    ];
  };

  return (
    <Dialog fullWidth maxWidth="sm" open={open} onClose={onClose}>
      <DialogTitle sx={{ pb: 2, display: 'flex' }}>เติมวงเงินหลักประกัน</DialogTitle>

      <DialogContent>
        <InfoGrid infos={getInfo()} />
      </DialogContent>

      <DialogActions>
        <Button variant="outlined" onClick={onClose}>
          ปิด
        </Button>
      </DialogActions>
    </Dialog>
  );
}
